import {designerToolsMap} from './designerToolsMap';
import {serverToolsMap} from './serverToolsMap';
import {mcpToolsMap} from './mcpToolsMap';

export const toolsMap = {
  ...designerToolsMap,
  ...serverToolsMap,
  ...mcpToolsMap,
};
